/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const GET_HOME_VIDEOS_PDF_MCQS_BY_TYPE = gql`
    query GetHomeListDataByType($type: String!) {
        getLists(type: $type) {
        id
        name
        contents {
            name
            url
            duration
            thumbnail
        }
        }
    }
`;

export const GET_HOME_PDFS = gql`
    query GetHomeListDataByType($type: String!) {
        getLists(type: $type) {
        id
        name
        contents {
            name
            url
            thumbnail
        }
        }
    }
`;

export const GET_ALL_LIST_CONTEST_BY_LIMIT = gql`
    query GetListContents($listId: ID!, $limit: Int, $offset: Int, $isHome: Boolean) {
    getListContents(listId: $listId, limit: $limit, offset: $offset, isHome: $isHome) {
        contents {
        id,
        name,
        url,
        type,
        thumbnail,
        contentId,
        duration,
        createdTime,
        quiz {
          id
          name
          quizType
          maximumMarks
          questionCount
          duration
          durationInSeconds
          createdAt
          userQuizResponse {
            attemptStatus
            attemptData {
              attemptLang
            }
          }
        }
       }
        list {
          id
          type
          name
          isSublist
          htmlDescription
    }
    }
  }
`;
export const GET_DAILY_HOME_MCQS = gql`
query GetLegacyDailyMcq($offset: Int, $limit: Int) {
  getLegacyDailyMcq(offset: $offset, limit: $limit) {
    streams {
      id
      name
      courseTestSeries {
        id
        session
        timeInMins
        totalMarks
        totalQuestions
        testSeriesName
        testSeriesReport {
          testSeriesId
          id
        }
        stream
      }
    }
  }
}
`;

export const GET_DATA_BY_LIST_ID = gql`
  query GetListContents($listId: ID!) {
  getListContents(listId: $listId) {
    contents {
      id
      contentId
      name,
      url,
      thumbnail
    }
  }
}
`;

export const GET_MCQS_BY_MONTH = gql`
  query GetDailyMCQSByMonth($filters: [ContentFilter], $offset: Int, $limit: Int) {
  getLegacyDailyMcq(filters: $filters, offset: $offset, limit: $limit) {
    total
    streams {
      id
      name,
      courseTestSeries {
        id
        session
        timeInMins
        totalMarks
        totalQuestions
        testSeriesName
        testSeriesReport {
          testSeriesId
          id
        }
        stream
      }
    }
  }
}`;
export const GET_VIDEOS_BY_YEAR_AND_MONTH = gql`
  query GetListContentsByMonthAndYear($listId: ID!, $limit: Int, $offset: Int, $filters: [ContentFilter!]) {
    getListContents(listId: $listId, limit: $limit, offset: $offset, filters: $filters) {
      contents {
        id
        name,
        url,
        thumbnail, 
        duration
      }
  }
}`;
